
  <!-- Sidebar -->
  <app-sidebar></app-sidebar>
  <div >
    <app-header></app-header> 
    <!-- Page Content -->
    <div id="content">
      <app-acompanhamento></app-acompanhamento> 
    </div>
    <app-footer></app-footer>
</div>